export default "__VITE_ASSET__$bjHQjIA__"